<template>
  <a-modal title="How It Works" :visible="visible" width="500px" @cancel="cancel" :destroy-on-close="true">
    <div class="flex flex-column gap-2">
      <a-alert
        message="Most actions in the system impact the rating. It's key to steer clear of negative events and zero in on the positive ones — that way, you can climb up the company rating ladder!"
        type="info"
        show-icon
      />
      <div v-for="(subGroups, polarity) in groupedItems" :key="polarity">
        <h2>{{ polarity }}</h2>

        <div v-for="(items, typeName) in subGroups" :key="typeName">
          <h3>{{ typeName }}</h3>
          <ul class="p-0">
            <li
              v-for="(item, idx) in items"
              :key="`${polarity}-${typeName}-${idx}`"
              class="flex justify-content-between"
            >
              <span>{{ item.name }}</span>
              <span
                :style="{
                  color: polarity === 'Positive' ? 'var(--success-color)' : 'var(--error-color)'
                }"
              >
                {{ polarity === 'Positive' ? '+' : '-' }}
                <b>{{ item.value }}</b>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="cancel"> Cancel </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { Alert } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapState: pointSystemState } = createNamespacedHelpers('pointSystem')

export default {
  components: {
    'a-alert': Alert
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...pointSystemState({
      types: state => state.types
    }),
    groupedItems() {
      const result = {
        Positive: {},
        Negative: {}
      }

      this.types.forEach(item => {
        const polarity = item.is_negative ? 'Negative' : 'Positive'
        const typeName = item.type_name
        const entry = {
          name: item.sub_type_name,
          value: Math.abs(item.value)
        }

        if (!result[polarity][typeName]) {
          result[polarity][typeName] = []
        }
        result[polarity][typeName].push(entry)
      })

      for (const polarity in result) {
        for (const typeName in result[polarity]) {
          result[polarity][typeName].sort((a, b) => b.value - a.value)
        }
      }

      return result
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
::v-deep .ant-modal-body {
  max-height: 600px;
  overflow: auto;
}
</style>
